import { IPrefillData } from "../../../../../stores/formsStore";
import { IFormTemplateJson } from "../../models";
import { getTemplateFieldBindings } from "../utils";
import validate from "./validations";



function createFormLevelValidator(formTemplateJson: IFormTemplateJson) {
  const fields =  Array.from(getTemplateFieldBindings(formTemplateJson));
  const fieldMap = new Map(fields.map(f => [f.binding, f]));

  const getFieldInfo = (fieldBinding: string) => fieldMap.get(fieldBinding) ?? null;
  const templateHasField = (bindingPrefix: string) => fields.some(f => f.binding.startsWith(bindingPrefix));
  const validateFields = (values: IPrefillData) => validate(values, getFieldInfo, templateHasField);

  return validateFields;
}

export default createFormLevelValidator;
